// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__6A_-v","header":"MergedInvoice_header__1_Pgh"};